import { render, staticRenderFns } from "./ProductInstructionsTab.vue?vue&type=template&id=4225a0bb&scoped=true&"
import script from "./ProductInstructionsTab.vue?vue&type=script&lang=js&"
export * from "./ProductInstructionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225a0bb",
  null
  
)

export default component.exports